import {
  Button,
  Empty,
  Input,
  Modal,
  Result,
  Space,
  Spin,
  Table,
} from 'antd'
import type { ColumnsType } from 'antd/es/table'
import useHook, { FILTER_FIELDS, TaxCategoryPicked } from './hooks'
import { TaxCategoryRow } from './tableRows'
import styles from './styles.module.scss'

export type { TaxCategoryPicked } from './hooks'

export interface Props {
  visible?: boolean
  /** 取消与右上角关闭都走这里，调用方原值保持不变 */
  onCancel: () => void
  /** 点击确定后回传选中的税编主数据，取消与关闭不触发 */
  onConfirm: (picked: TaxCategoryPicked) => void
  title?: string
}

/**
 * 选择税收分类弹窗，受控组件。
 *
 * 数据来自 MPM 本地税编库（SCP 后端 → MPMApi → MPM open/srm 接口），与 MPM 管理端同一份。
 * 树形表格展示，四个业务字段整条可见；行首单选按钮只出现在 selectable 的行上——
 * 该标志与 MPM 保存校验同源，不要在 SCP 侧自行判断税率是否可用。
 */
export default function TaxCategoryPicker(props: Props) {
  const { visible, onCancel, onConfirm, title = '选择税收分类' } = props
  const {
    status,
    rows,
    expandedRowKeys,
    selectedCode,
    filters,
    filtered,
    setExpandedRowKeys,
    setFilter,
    handleSearch,
    handleReset,
    handleRetry,
    handleSelectRow,
    handleRowClick,
    handleConfirm,
  } = useHook({ visible, onConfirm, onCancel })

  const columns: ColumnsType<TaxCategoryRow> = [
    {
      title: '税收分类名称',
      dataIndex: 'name',
      ellipsis: true,
      render: (name: string, row) => (
        <span className={row.matched ? styles['matched'] : undefined}>
          {name}
        </span>
      ),
    },
    {
      title: '简称',
      dataIndex: 'shortName',
      width: 130,
      ellipsis: true,
      render: (shortName: string | null) => shortName || '-',
    },
    {
      title: '税收分类编码',
      dataIndex: 'code',
      width: 180,
    },
    {
      title: '税率',
      dataIndex: 'rateRaw',
      width: 100,
      render: (rateRaw: string | null) => rateRaw || '-',
    },
  ]

  const renderBody = () => {
    if (status === 'loading') {
      return (
        <div className={styles['placeholder']}>
          <Spin tip="税编加载中..." />
        </div>
      )
    }
    if (status === 'error') {
      return (
        <div className={styles['placeholder']}>
          <Result
            status="warning"
            subTitle="税编数据查询失败，原有税编信息未被修改"
            extra={
              <Button type="primary" onClick={handleRetry}>
                重试
              </Button>
            }
          />
        </div>
      )
    }
    if (status === 'empty') {
      return (
        <div className={styles['placeholder']}>
          <Empty
            description={filtered ? '没有匹配的税收分类编码' : '税编库暂无数据'}
          />
        </div>
      )
    }
    return (
      <Table<TaxCategoryRow>
        rowKey="code"
        size="small"
        columns={columns}
        dataSource={rows}
        pagination={false}
        scroll={{ y: 400 }}
        rowSelection={{
          type: 'radio',
          selectedRowKeys: selectedCode ? [selectedCode] : [],
          // 税率为空或多值的行不给单选按钮，整行不可选
          renderCell: (_checked, row, _index, originNode) =>
            row.selectable ? (
              // 阻断冒泡，点单选按钮时不要连带展开这一行
              <span onClick={(event) => event.stopPropagation()}>
                {originNode}
              </span>
            ) : null,
          onSelect: handleSelectRow,
        }}
        expandable={{
          expandedRowKeys,
          onExpandedRowsChange: (keys) =>
            setExpandedRowKeys(keys.map((key) => String(key))),
          // 点整行就能展开收起，不必非点行首的加减号
          expandRowByClick: true,
        }}
        onRow={(row) => ({
          className:
            (row.children && row.children.length) || row.selectable
              ? styles['clickable-row']
              : undefined,
          onClick: () => handleRowClick(row),
        })}
      />
    )
  }

  return (
    <Modal
      title={
        <>
          {title}
          <span className={styles['title-tip']}>
            点击行可展开收起下级，末级行点击即选中；税率为空或存在多个税率的编码无法唯一确定物料税率，不提供选择按钮
          </span>
        </>
      }
      open={visible}
      width={900}
      destroyOnClose
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="确定"
      cancelText="取消"
      okButtonProps={{ disabled: !selectedCode }}
    >
      <div className={styles['search']}>
        {FILTER_FIELDS.map(({ label, field }) => (
          <div className={styles['filter-item']} key={field}>
            <span className={styles['filter-label']}>{label}：</span>
            <Input
              className={styles['filter-input']}
              value={filters[field]}
              placeholder={label}
              allowClear
              onChange={(e) => setFilter(field, e.target.value)}
              onPressEnter={handleSearch}
            />
          </div>
        ))}
        <Space size={8}>
          <Button type="primary" onClick={handleSearch}>
            查询
          </Button>
          <Button onClick={handleReset}>重置</Button>
        </Space>
      </div>
      {renderBody()}
    </Modal>
  )
}
import {
  Button,
  Empty,
  Input,
  Modal,
  Result,
  Space,
  Spin,
  Table,
} from 'antd'
import type { ColumnsType } from 'antd/es/table'
import useHook, { FILTER_FIELDS, TaxCategoryPicked } from './hooks'
import { TaxCategoryRow } from './tableRows'
import styles from './styles.module.scss'

export type { TaxCategoryPicked } from './hooks'

export interface Props {
  visible?: boolean
  /** 取消与右上角关闭都走这里，调用方原值保持不变 */
  onCancel: () => void
  /** 点击确定后回传选中的税编主数据，取消与关闭不触发 */
  onConfirm: (picked: TaxCategoryPicked) => void
  title?: string
}

/**
 * 选择税收分类弹窗，受控组件。
 *
 * 数据来自 MPM 本地税编库（SCP 后端 → MPMApi → MPM open/srm 接口），与 MPM 管理端同一份。
 * 树形表格展示，四个业务字段整条可见；行首单选按钮只出现在 selectable 的行上——
 * 该标志与 MPM 保存校验同源，不要在 SCP 侧自行判断税率是否可用。
 */
export default function TaxCategoryPicker(props: Props) {
  const { visible, onCancel, onConfirm, title = '选择税收分类' } = props
  const {
    status,
    rows,
    expandedRowKeys,
    selectedCode,
    filters,
    filtered,
    setExpandedRowKeys,
    setFilter,
    handleSearch,
    handleReset,
    handleRetry,
    handleSelectRow,
    handleRowClick,
    handleConfirm,
  } = useHook({ visible, onConfirm, onCancel })

  const columns: ColumnsType<TaxCategoryRow> = [
    {
      title: '税收分类名称',
      dataIndex: 'name',
      ellipsis: true,
      render: (name: string, row) => (
        <span className={row.matched ? styles['matched'] : undefined}>
          {name}
        </span>
      ),
    },
    {
      title: '简称',
      dataIndex: 'shortName',
      width: 130,
      ellipsis: true,
      render: (shortName: string | null) => shortName || '-',
    },
    {
      title: '税收分类编码',
      dataIndex: 'code',
      width: 180,
    },
    {
      title: '税率',
      dataIndex: 'rateRaw',
      width: 100,
      render: (rateRaw: string | null) => rateRaw || '-',
    },
  ]

  const renderBody = () => {
    if (status === 'loading') {
      return (
        <div className={styles['placeholder']}>
          <Spin tip="税编加载中..." />
        </div>
      )
    }
    if (status === 'error') {
      return (
        <div className={styles['placeholder']}>
          <Result
            status="warning"
            subTitle="税编数据查询失败，原有税编信息未被修改"
            extra={
              <Button type="primary" onClick={handleRetry}>
                重试
              </Button>
            }
          />
        </div>
      )
    }
    if (status === 'empty') {
      return (
        <div className={styles['placeholder']}>
          <Empty
            description={filtered ? '没有匹配的税收分类编码' : '税编库暂无数据'}
          />
        </div>
      )
    }
    return (
      <Table<TaxCategoryRow>
        rowKey="code"
        size="small"
        columns={columns}
        dataSource={rows}
        pagination={false}
        scroll={{ y: 400 }}
        rowSelection={{
          type: 'radio',
          selectedRowKeys: selectedCode ? [selectedCode] : [],
          // 税率为空或多值的行不给单选按钮，整行不可选
          renderCell: (_checked, row, _index, originNode) =>
            row.selectable ? (
              // 阻断冒泡，点单选按钮时不要连带展开这一行
              <span onClick={(event) => event.stopPropagation()}>
                {originNode}
              </span>
            ) : null,
          onSelect: handleSelectRow,
        }}
        expandable={{
          expandedRowKeys,
          onExpandedRowsChange: (keys) =>
            setExpandedRowKeys(keys.map((key) => String(key))),
          // 点整行就能展开收起，不必非点行首的加减号
          expandRowByClick: true,
        }}
        onRow={(row) => ({
          className:
            (row.children && row.children.length) || row.selectable
              ? styles['clickable-row']
              : undefined,
          onClick: () => handleRowClick(row),
        })}
      />
    )
  }

  return (
    <Modal
      title={
        <>
          {title}
          <span className={styles['title-tip']}>
            点击行可展开收起下级，末级行点击即选中；税率为空或存在多个税率的编码无法唯一确定物料税率，不提供选择按钮
          </span>
        </>
      }
      open={visible}
      width={900}
      destroyOnClose
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="确定"
      cancelText="取消"
      okButtonProps={{ disabled: !selectedCode }}
    >
      <div className={styles['search']}>
        {FILTER_FIELDS.map(({ label, field }) => (
          <div className={styles['filter-item']} key={field}>
            <span className={styles['filter-label']}>{label}：</span>
            <Input
              className={styles['filter-input']}
              value={filters[field]}
              placeholder={label}
              allowClear
              onChange={(e) => setFilter(field, e.target.value)}
              onPressEnter={handleSearch}
            />
          </div>
        ))}
        <Space size={8}>
          <Button type="primary" onClick={handleSearch}>
            查询
          </Button>
          <Button onClick={handleReset}>重置</Button>
        </Space>
      </div>
      {renderBody()}
    </Modal>
  )
}
